export default {
	//客户案例
	projectCate: "/v1/projectCate",
	casusList: "v1/casusList",
	//新闻
	newsCenter: "v1/newsCenter",
	articleList: "v1/articleList",
	toAdd:"channel/consult/add"
};
